<template>
  <div>
    <div v-show="!showLoader" >
      <router-view :key="$route.fullPath"></router-view>
      <Footer></Footer>
    </div>  

    <Loader v-show="showLoader" ></Loader>  
  </div>
</template>
<script>

import Footer from "./components/partials/Footer";
import Loader from "./components/partials/Loader";

export default {
  components: {
    Footer,
    Loader,
  },
  computed: {
    showLoader() {
      return this.$store.getters["app/loader"];
    },
  },
 created () {
    setTimeout(function(){ this.pageFinishedLoading() }.bind(this), 3000);
  }, 
  mounted() {
    document.title = "Episcenter klub";
    
    if(this.$route.query.rtp) {
      try{
        const rtpNumber = parseInt(this.$route.query.rtp);
        this.$cookie.set('rtp', rtpNumber, 7);
      }
      catch(err){
        console.error(err)
      }
    }
    
    // Create the gtag script
		const gtagScript = document.createElement('script');
		gtagScript.setAttribute('async', '');
		gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-K3VXX9M636';
		document.head.appendChild(gtagScript);
    
		const gtagInitScript = document.createElement('script');
		gtagInitScript.innerHTML = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', 'G-K3VXX9M636');
		`;
		document.head.appendChild(gtagInitScript);
  },
  methods :{
      pageFinishedLoading()
      {
        this.$store.dispatch("app/loader", false);
      }
  },
};
</script>

<style src='./assets/css/ie.css'></style>
<style src='./assets/css/fonts.css'></style>
<style src='./assets/css/app.css'></style>
